const prefix = ['app', 'appraisalAdmin', 'letterCaseSetting'];

export const getCaseSettingState = state =>
    state.getIn([...prefix, 'caseSetting', 'state']);
export const getCaseSettingData = state =>
    state.getIn([...prefix, 'caseSetting', 'data'], 'Upper Lower Case');
export const getCaseSettingOptionsState = state =>
    state.getIn([...prefix, 'caseSettingOptions', 'state']);
export const getCaseSettingOptionsData = state =>
    state.getIn([...prefix, 'caseSettingOptions', 'data'], {}).toJS();
